import React, { FC } from 'react';
import { Button, Flex, Loader, Paragraph } from '@wunder-mobility/ui-components';
import styles from '@/features/booking/assets/scss/components/BookingFlow/RequestBookingBanner.module.scss';
import { Trans } from '@lingui/react/macro';
import { useRequestSharedSettingQuery } from '@/core/services/SettingsManagement.service';
import { useParams } from 'react-router';

interface RequestBookingBannerT {
  onBookingRequested: () => void;
}

const RequestBookingBanner: FC<RequestBookingBannerT> = ({ onBookingRequested }) => {
  const { branchId } = useParams();
  const {
    data: sharedBookingSetting,
    isFetching: isFetchingBookingSharedSettings,
    isError,
  } = useRequestSharedSettingQuery(+branchId!, {
    skip: !branchId,
  });

  if (isFetchingBookingSharedSettings) {
    return <Loader cover />;
  }

  if (isError || !sharedBookingSetting?.value?.request?.enabled) {
    return null;
  }

  return (
    <Flex align="center" justify="space-between" className={styles['request-booking-banner']}>
      <Flex direction="column">
        <Paragraph marginBottom={4} size={3}>
          <Trans id="bookings.requestBookingBanner.noAvailableSlot">Need something specific?</Trans>
        </Paragraph>
        <Paragraph marginBottom={0} textColor="text-600" size={4}>
          <Trans id="bookings.requestBookingBanner.requestBookingDescription">
            You can request a booking instead.
          </Trans>
        </Paragraph>
      </Flex>
      <Button size="small" onClick={onBookingRequested}>
        <Trans id="bookings.requestBookingBanner.requestBookingTitle">Request booking</Trans>
      </Button>
    </Flex>
  );
};

export default RequestBookingBanner;
